export default {
  // 获取token、刷新token
  getToken: '/oauth/token',
  // 点击访问量
  clickPlayCount: '/member/anonymous/amc/statistics/clickPlayCount',
  // 增加积分
  addScore: '/member/anonymous/amc/unifiedScore',

    /* 评论相关接口，适用于以下类型 */
  /* contentType 内容类型：*/
  /* 1:图文资讯 2:图集 3:广告 4:专题 5:活动 6:投票调查 7:直播 8:抽奖 9:视频 */
  // 评论列表接口(评论回复列表接口)
  getCommentListByNewsId: '/member/anonymous/amc/listCommentsWithChildsByContentIdAndTypeAndParentId',
  // 新增评论
  addComment: '/member/anonymous/amc/addCommentData',

  /* 点赞相关接口，适用于以下类型 */
  /* contentType 内容类型：*/
  /* 1:活动 2:抽奖 3:投票调查 4:直播间 5:图文资讯 6:图集 7:专题 8:占位广告 9:视频 11:音频 12:外链 16:报料 */
  // 查询点赞状态接口
  queryThumbsUpStatus: '/member/anonymous/amc/findUserLikesByContentIdAndMemberOrDeviceId',
  // 点赞接口
  giveThumbsUp: '/member/anonymous/amc/addTopDataByContent',
  // 取消点赞接口
  cancelThumbsUp: '/member/anonymous/amc/deleteTopDataByContent',
  // 评论点赞
  giveThumbsUpComment: '/member/anonymous/amc/addTopDataComment',
  // 获取点赞类型及相关图标
  getAppFunButtonConfigNew: '/member/anonymous/amc/getAppFunButtonConfigNew',

  /* 收藏 */
  addMemberCollect: '/member/anonymous/amc/addMemberCollect',
  /* 取消收藏 */
  cancelMemberCollect: '/member/anonymous/amc/cancelMemberCollect',
  /* 获取微信Ticket */
  getWeiXinTicket: '/member/anonymous/amc/getWeiXinTicket',

  /* 保存h5访问数据 */
  saveH5Data: '/member/anonymous/saveH5Data',
}